import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Parameter = {
  companyId: string
  category?: string
  domainId?: string
  options?: Pick<UseQueryOptions, 'enabled'>
}

type Response = {
  category: string
}[]

export async function getRelatedCategories({
  category,
  companyId,
  domainId,
}: Parameter) {
  const encodedCategory = category && encodeURIComponent(category)
  const url = new URL(
    `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keyword-discovery/domains/${domainId}/categories/related`
  )
  if (encodedCategory) {
    url.searchParams.append('category', encodedCategory)
  }

  try {
    const response = await axios.get(url.toString())
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useGetRelatedCategories({
  companyId,
  domainId,
  category,
  options,
}: Parameter) {
  return useQuery({
    queryKey: ['related-categories', companyId, domainId, category],
    queryFn: () => getRelatedCategories({ companyId, domainId, category }),
    retry: false,
    enabled: options?.enabled,
    ...options,
  })
}
